import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sms-gift-redemption",
  "use": "icon-sms-gift-redemption-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sms-gift-redemption\"><path d=\"M512 85.333333C276.053333 85.333333 85.333333 276.053333 85.333333 512s190.72 426.666667 426.666667 426.666667 426.666667-190.72 426.666667-426.666667S747.946667 85.333333 512 85.333333z m0 796.444445c-204.8 0-370.346667-165.546667-370.346667-369.777778S307.2 141.797333 512 141.797333 882.346667 307.768889 882.346667 512 716.8 881.777778 512 881.777778z\" p-id=\"9001\" /><path d=\"M716.8 394.24l-38.968889-38.968889-235.633778 235.633778-96.711111-96.711111-38.968889 38.968889 135.68 135.964444 274.204445-274.204444z\" p-id=\"9002\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sms-gift-redemption.svg
// module id = 5Lzk
// module chunks = 57